export const SOURCE_PRODUCT = 'product';
export const SOURCE_BUNDLE = 'product-bundle';
export const SOURCE_TREE = 'tree';
export const SOURCE_PROVISION = 'provision';
export const SOURCE_PROVISION_EBOOK_SAMPLE = 'provision-ebook-sample';
export const SOURCE_TREE_DEFINITION = 'tree-definition';
export const ACCESS_READ = 'read';
export const ACCESS_WRITE = 'write';

export const SOURCES = {
  [SOURCE_PRODUCT]: 'Produkt',
  [SOURCE_BUNDLE]: 'Produktový svazek',
  [SOURCE_TREE]: 'Strom kategorií',
  [SOURCE_PROVISION]: 'Provisioning',
  [SOURCE_PROVISION_EBOOK_SAMPLE]: 'Ukázka ebooku (Provision API)',
  [SOURCE_TREE_DEFINITION]: 'Přístup k trees',
};

export const ACCESS_TYPES = {
  [ACCESS_READ]: 'Čtení',
  [ACCESS_WRITE]: 'Zápis',
};

export const EQUAL = 'eq';
export const LIKE = 'like';
export const NOT = 'not';

export const OPERATORS = {
  [EQUAL]: { displayValue: 'je', joinWord: 'nebo' },
  [LIKE]: { displayValue: 'obsahuje', joinWord: 'nebo' },
  [NOT]: { displayValue: 'není', joinWord: 'ani' },
};

export const RULE_KEYS = {
  [SOURCE_PRODUCT]: {
    type: {
      label: 'Typ produktu',
      operators: [EQUAL, NOT],
      baseOperator: EQUAL,
      field: 'multiselect',
      options: {
        audiobook: 'Audiobook',
        ebook: 'Ebook',
        physicalgood: 'Fyzické zboží',
        physicalgoodsnonbooks: 'Fyzické zboží neknižní',
      },
    },
    publisher: { label: 'Název vydavatele', operators: [LIKE, NOT], baseOperator: LIKE, field: 'multitext' },
    publisherId: {
      label: 'ID vydavatele',
      operators: [EQUAL, NOT],
      baseOperator: EQUAL,
      field: 'publisher-autocomplete',
    },
    brand: { label: 'Název značky', operators: [LIKE, NOT], baseOperator: LIKE, field: 'multitext' },
    brandId: {
      label: 'ID značky',
      operators: [EQUAL, NOT],
      baseOperator: EQUAL,
      field: 'brand-autocomplete',
    },
    available: { label: 'Pouze publikované', value: ['1'] },
  },
  [SOURCE_BUNDLE]: {},
  [SOURCE_TREE]: {},
  [SOURCE_PROVISION]: {},
  [SOURCE_PROVISION_EBOOK_SAMPLE]: {},
  [SOURCE_TREE_DEFINITION]: {},
};

export const isObjectEmpty = (object) => !object || Object.keys(object).length === 0;

export const removeKeyFromObject = (object, keyToRemove) => {
  const { [keyToRemove]: removed, ...newObject } = object;
  return newObject;
};

export const getRuleDefinition = (source, ruleKey) => {
  const [ruleKeyBase, operator] = ruleKey.split('.');
  const ruleDefinition = RULE_KEYS[source]?.[ruleKeyBase];
  return {
    ruleDefinition,
    operator: operator || ruleDefinition?.baseOperator || EQUAL,
  };
};

export const getPossibleRuleKeys = (existingRules, source) => {
  const rulesConfig = RULE_KEYS[source] || {};
  const allCombinations = Object.keys(rulesConfig).reduce((prevResult, currentBaseKey) => {
    const ruleDef = rulesConfig[currentBaseKey];
    const allAvailableRules = !ruleDef.operators ? [{ key: currentBaseKey, label: ruleDef.label }] : ruleDef.operators.map((op) => ({
      key: ruleDef.baseOperator && ruleDef.baseOperator === op ? currentBaseKey : `${currentBaseKey}.${op}`,
      label: `${ruleDef.label} (${OPERATORS[op].displayValue})`,
    }));
    return [...prevResult, ...allAvailableRules];
  }, []);
  return allCombinations.filter((item) => !Object.keys(existingRules).includes(item.key));
};

export const shouldDisplayOperator = (ruleDefinition) => !ruleDefinition || (ruleDefinition && ruleDefinition.operators);

export const shouldDisplayField = (ruleDefinition) => !ruleDefinition || (ruleDefinition && ruleDefinition.field);

export const getRuleValue = (possibleValues, options, joinWord = 'nebo') => {
  const displayedValues = options ? possibleValues.map((value) => options[value]) : possibleValues;
  return displayedValues.map((item) => `"${item}"`).join(` ${joinWord} `);
};
